import React from 'react';
import { Link } from 'react-router-dom';
const NAV_LINKS = [{
  name: 'Home',
  href: '/'
}, {
  name: 'About',
  href: '/about'
}, {
  name: 'Experience',
  href: '/experience'
}, {
  name: 'Projects',
  href: '/projects'
}, {
  name: 'Contact',
  href: '/contact'
}];
export function Footer() {
  return <footer className="bg-navy-900 py-12 border-t border-white/10" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between" data-id="element-20">
        <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-21">
          <Link to="/" className="text-white font-serif text-xl font-bold tracking-wider block mb-2" data-id="element-22">
            Bryan E. Nicholson
          </Link>
          <p className="text-white/50 text-sm" data-id="element-23">
            &copy; {new Date().getFullYear()} Bryan E. Nicholson. All rights
            reserved.
          </p>
        </div>

        <nav className="flex flex-wrap justify-center gap-6" data-id="element-24">
          {NAV_LINKS.map(link => <Link key={link.name} to={link.href} className="text-white/60 hover:text-gold transition-colors text-sm font-medium" data-id="element-25">
              {link.name}
            </Link>)}
        </nav>
      </div>
    </footer>;
}